import { getCauseMessage } from './get-cause-message';

export function resolveEventCause(
  originalException: unknown,
  contextCause: unknown,
): string | undefined {
  const fromHint = getCauseMessage(originalException);
  if (fromHint) {
    return fromHint;
  }
  return typeof contextCause === 'string' && contextCause.length > 0 ? contextCause : undefined;
}
